<!--
  - Copyright (c) 2019 LNBIG.com
  - All rights reserved.
  -->

<template>
  <v-row
      align="center"
      justify="center"
  >
    <v-col
        class="text-center my-3"
        cols="12"
    >
      <v-card>
        <v-toolbar
            color="light-green"
            dark
        >
          <v-toolbar-title>Open a channel to LNBIG</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col
                v-for="i in amountRandomNodes"
                :key="i"
                v-bind="breakpointsRandomNodes"
                class="ma-2"
            >
              <card-node
                  :key="i"
                  :node-data="randomNodes[i - 1]"
                  :show-info="showInfo"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
        class="text-center my-3"
        cols="12"
    >
      <open-channel-wizard :uuid="$attrs.oc_uuid"/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  computed: {
    randomNodes() {
      return this.$store.state.nodeList.map(v => [v, Math.random()]).sort((a, b) => a[1] - b[1]).map(v => v[0])
    },
    amountRandomNodes() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 1
        case 'sm':
          return 2
        case 'md':
          return 3
        case 'lg':
          return 4
        case 'xl':
          return 6
      }
      return 1
    },
    breakpointsRandomNodes() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return {xs12: true}
        case 'sm':
          return {sm6: true}
        case 'md':
          return {md4: true}
        case 'lg':
          return {lg3: true}
        case 'xl':
          return {xl2: true}
      }
      return {xs12: true}

    },
    showInfo() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return true
        case 'sm':
          return true
        case 'md':
          return true
        case 'lg':
          return false
        case 'xl':
          return true
      }
      return true
    }
  }
}
</script>
